export function addFootnoteAndAdjustSpacing(footnote) {
    const footnoteExists = document.getElementById('footNote');
    if (footnoteExists) footnoteExists.remove();
    
    if (footnote.length > 0) {
        let tradingData = document.getElementById('tradingData');
        let footnoteDiv = document.createElement('div');
        footnoteDiv.className = 'text-xxs text-secondary';
        footnoteDiv.style.display = 'block';
        footnoteDiv.style.clear = 'both';
        footnoteDiv.innerHTML = footnote;
        footnoteDiv.setAttribute('id', 'footNote');
        tradingData.appendChild(footnoteDiv);
    }
}